<template>
  <CollapsibleCard collapsible>
    <template #header>
      <div class="flex items-center gap-3">
        <h3 class="text-base font-semibold">{{ title }}</h3>
        <USwitch
          :model-value="active"
          :disabled="disabled"
          @update:model-value="$emit('update:active', $event)"
          @click.stop
        />
        <UBadge :color="active ? 'success' : 'neutral'" variant="subtle">
          {{ active ? 'Aktiv' : 'Inaktiv' }}
        </UBadge>
      </div>
    </template>

    <div class="space-y-4">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <UFormField label="Ablagepfad">
          <template #label>
            <div class="flex items-center gap-1">
              Ablagepfad
              <UTooltip
                text="Muss entweder mit einem Pilcrow oder ARCPATH starten. Templates mit z.B. addressNo sind erlaubt."
              >
                <UIcon class="w-4 h-4 text-gray-400" name="i-lucide-info" />
              </UTooltip>
            </div>
          </template>
          <UInput
            :model-value="path"
            :disabled="disabled"
            class="w-full"
            placeholder="¶Archiv¶Pfad"
            @update:model-value="$emit('update:path', $event)"
          >
            <template #trailing>
              <UButton
                v-if="!disabled"
                color="neutral"
                label="¶"
                size="xs"
                variant="ghost"
                @click="$emit('update:path', (path || '') + '¶')"
              />
            </template>
          </UInput>
        </UFormField>
        <UFormField label="Name der Akte">
          <template #label>
            <div class="flex items-center gap-1">
              Name der Akte
              <UTooltip text="Templates mit z.B. addressNo sind erlaubt.">
                <UIcon class="w-4 h-4 text-gray-400" name="i-lucide-info" />
              </UTooltip>
            </div>
          </template>
          <UInput
            :model-value="name"
            :disabled="disabled"
            class="w-full"
            placeholder="Akte"
            @update:model-value="$emit('update:name', $event)"
          />
        </UFormField>
      </div>

      <div class="mt-4">
        <h4 class="text-sm font-bold mb-2">Unterordnerstruktur</h4>
        <div class="space-y-2">
          <div v-for="(folder, index) in subfolders" :key="index" class="flex gap-2">
            <UInput
              :model-value="folder as string"
              :disabled="disabled"
              class="flex-1"
              size="sm"
              @update:model-value="updateSubfolder(index, $event as string)"
            >
              <template #trailing>
                <UButton
                  v-if="!disabled"
                  color="neutral"
                  label="¶"
                  size="xs"
                  variant="ghost"
                  @click="updateSubfolder(index, ((folder as string) || '') + '¶')"
                />
              </template>
            </UInput>
            <UButton
              v-if="!disabled"
              color="danger"
              icon="i-lucide-trash"
              size="xs"
              variant="ghost"
              @click="removeSubfolder(index)"
            />
          </div>
          <UButton
            v-if="!disabled"
            color="primary"
            icon="i-lucide-plus"
            label="Zeile hinzufügen"
            size="sm"
            variant="outline"
            @click="addSubfolder"
          />
        </div>
      </div>
    </div>
  </CollapsibleCard>
</template>

<script lang="ts" setup>
import CollapsibleCard from './CollapsibleCard.vue'

const props = defineProps({
  title: String,
  active: Boolean,
  name: String,
  path: String,
  subfolders: {
    type: Array,
    default: () => [],
  },
  disabled: Boolean,
})

const emit = defineEmits(['update:active', 'update:name', 'update:path', 'update:subfolders'])

const updateSubfolder = (index: number, value: string) => {
  const newFolders = [...props.subfolders]
  newFolders[index] = value
  emit('update:subfolders', newFolders)
}

const addSubfolder = () => {
  const currentSubfolders = (props.subfolders as string[]) || []
  emit('update:subfolders', [...currentSubfolders, ''])
}

const removeSubfolder = (index: number) => {
  const newFolders = [...props.subfolders]
  newFolders.splice(index, 1)
  emit('update:subfolders', newFolders)
}
</script>
